import { initializeApp,  } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBWXc8Tzjlr9EV5pmRe2KrcZQTQdlveuR8",
  authDomain: "corolla-roofing.firebaseapp.com",
  projectId: "corolla-roofing",
  databaseURL: "https://corolla-roofing-default-rtdb.firebaseio.com",
  storageBucket: "corolla-roofing.appspot.com",
  messagingSenderId: "574951273421",
  appId: "1:574951273421:web:ac130d3433fce95a4b8a84",
  measurementId: "G-Q49KH6DJJ8"
};

  // Initialize Firebase
const app = initializeApp(firebaseConfig);
export const firebaseDb = getDatabase(app);
export const storage = getStorage(app);
// export default firebaseDb